/**
 * "What do you want?" intents (Shop experiment `intent-segment`).
 * Each intent maps onto existing event category labels (filtered in place on the
 * landing list) or onto a route (Places with category params, Game).
 */

export const INTENT_STORAGE_KEY = 'm2b-intent';

export const INTENTS = Object.freeze([
  {
    id: 'date',
    title: 'Date',
    tagline: 'Low-lit corners. Shared plates.',
    glyph: '♥',
    href: '/places?category=Food&category=Drinks&category=Culture',
  },
  {
    id: 'coffee',
    title: 'Coffee',
    tagline: 'Strong brew. Wi-Fi optional.',
    glyph: '☕',
    href: '/places?category=Coffee',
  },
  {
    id: 'parties',
    title: 'Parties',
    tagline: 'Late nights. Heavy bass.',
    glyph: '♫',
    eventCategories: ['Nightlife'],
  },
  {
    id: 'exhibitions',
    title: 'Exhibitions',
    tagline: 'Visual stories. Local art.',
    glyph: '◩',
    eventCategories: ['Art'],
  },
  {
    id: 'hangout',
    title: 'Hangout',
    tagline: 'Good vibes. No agenda.',
    glyph: '☺',
    eventCategories: ['Live Music'],
  },
  {
    id: 'explore',
    title: 'Explore',
    tagline: 'No map. Just intuition.',
    glyph: '✧',
    href: '/game',
  },
]);

const INTENT_BY_ID = new Map(INTENTS.map((intent) => [intent.id, intent]));

export function intentById(id) {
  return INTENT_BY_ID.get(id) || null;
}

export function readStoredIntent() {
  try {
    const raw = window.localStorage.getItem(INTENT_STORAGE_KEY);
    return INTENT_BY_ID.has(raw) ? raw : '';
  } catch {
    return '';
  }
}

export function writeStoredIntent(id) {
  try {
    if (id && INTENT_BY_ID.has(id)) window.localStorage.setItem(INTENT_STORAGE_KEY, id);
    else window.localStorage.removeItem(INTENT_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
